import axios from 'axios';
import router from './router'; 

const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true, 
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    const url = config.url || '';
    const isPublicRequest = url.includes('/buscarComarcaConsultaExterna')
      || url.includes('/buscarUnidadesPorComarcaConsultaExterna')
      || url.includes('/buscarUnidadePublica')
      || url.includes('/buscarComarcaPublica')
      || url.includes('/sitemap.xml');

    if (token && !isPublicRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); 
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) { //rota acionada quando o token está inválido ou vencido.
      localStorage.removeItem('auth_token'); 
      router.push('/login'); 
    }
    return Promise.reject(error); 
  }
);



export default apiClient;
